export default [
    {
        path: '/notifications',
        name: 'notifications-root',

        component: () => import('source/pages/root/InternalPageRoot.vue'),
        meta: {
            title: 'Notifications Page Root',
            canDisplayGlobalModals: true,
        },
        children: [
            {

                path: '',
                name: 'notifications',
                component: () => import('source/pages/notifications/NotificationsPage.vue'),
                meta: {
                    title: 'Notifications - HQZen',
                    isInternal: true,
                    isCompanyIndependent: true
                }
            }
        ]
    },
];
